export default __webpack_public_path__ + "static/media/xlsxfile.8f3c722c.svg";